import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';

/**
 * フォームグループのエラーチェック
 * @param group フォームグループ
 * @param names チェックコントロール名
 * @param isUpdate 更新フラグ
 * @returns エラーフラグ
 */
export function checkFormGroupValidate(group: FormGroup, names: Array<string>, isUpdate = false) {
  //FormGroupのバリデーションを強制起動
  if (isUpdate) {
    group.updateValueAndValidity();
    group.markAllAsTouched();
  }
  return names.some((name) => group.controls[name].errors);
}
/**
 * フォームコントロールのエラーチェック
 * @param kist フォームコントロールリスト
 * @param isUpdate 更新フラグ
 * @returns エラーフラグ
 */
export function checkFormListValidate(list: Array<FormControl>, isUpdate = false) {
  //FormGroupのバリデーションを強制起動
  if (isUpdate) {
    list.forEach((fc) => {
      fc.updateValueAndValidity();
      fc.markAllAsTouched();
    });
  }
  return list.some((fc) => fc.errors);
}

/**
 * 変更された場合のみフォームコントロールのエラーチェック
 * @param kist フォームコントロールリスト
 * @param isUpdate 更新フラグ
 * @returns エラーフラグ
 */
export function checkFormListValidateWhenDirty(list: Array<FormControl>, isUpdate = false) {
  //FormGroupのバリデーションを強制起動
  if (isUpdate) {
    list.forEach((fc) => {
      //変更された場合のみバリデーション起動
      if (fc.dirty) {
        fc.updateValueAndValidity();
      }
      fc.markAllAsTouched();
    });
  }
  return list.some((fc) => fc.errors);
}

/**
 * 一致エラーチェック
 * @param form1 フォームコントロール1
 * @param form2 フォームコントロール2　不一致の場合にエラーがセットされる
 * @param error セットするエラー内容
 * @return エラーか否か
 */
export function checkFormEqual(form1: FormControl, form2: FormControl, error: ValidationErrors) {
  if (form1.value !== form2.value) {
    form2.setErrors(error);
    form2.markAllAsTouched();
    return true;
  }
  return false;
}

/**
 * 変更された場合のみ一致エラーチェック
 * @param form1 フォームコントロール1
 * @param form2 フォームコントロール2　不一致の場合にエラーがセットされる
 * @param error セットするエラー内容
 * @return エラーか否か
 */
export function checkFormEqualWhenDirty(form1: FormControl, form2: FormControl, error: ValidationErrors) {
  if ((form1.dirty || form2.dirty) && form1.value !== form2.value) {
    form2.setErrors(error);
    form2.markAllAsTouched();
    return true;
  }
  return false;
}
